<template>
  <div class="bg-white p-[24px] -mt-[8px] rounded-[8px] box-shadow-[0_4px_8px_0_rgba(0,0,0,0.1)]">
    <div class="flex items-center gap-[16px] mb-[24px]">
      <b-button
        variant="primary"
        size="sm"
        class="!p-[8px]"
        @click="$router.go(-1)"
      >
        <span class="k-arrow-left-2 text-[16px] font-bold" />
      </b-button>
      <h2 class="text-[20px] font-semibold text-[#333333] mb-0">
        Detail Order Packing
      </h2>
    </div>

    <div
      v-if="isError"
      class="mx-[20px] h-[150px] flex flex-col items-center justify-center gap-[10px]"
    >
      <p class="mb-0">
        Gagal mengambil data, silahkan coba lagi.
      </p>
      <b-button
        variant="primary"
        size="sm"
        class="!p-[8px] !flex items-center gap-[4px] justify-center"
        :disabled="loading"
        @click="handleRetry"
      >
        <b-spinner
          v-if="loading"
          variant="light"
          small
        />
        <span
          v-else
          class="k-refresh text-[14px] font-bold"
        />
        Coba Lagi
      </b-button>
    </div>
    <div v-else>
      <div class="text-black m-[20px]">
        <detail-row title="No. Order">
          <div
            class="flex items-center gap-[8px]"
            :class="loadingRowClass"
          >
            <img
              v-if="!loading"
              :src="marketplaceLogo"
              alt="marketplace"
              width="16"
            >
            <p>{{ data.marketplace_order_id }}</p>
          </div>
        </detail-row>
        <detail-row title="Label Pengiriman">
          <div
            :class="loadingRowClass"
            class="flex items-center py-[2px] gap-[10px]"
          >
            <b-button
              v-if="data.awb"
              variant="ghost"
              class="!text-black !font-normal hover:!underline transition-all duration-300 !p-0 !flex items-center gap-[4px]"
              :disabled="isPrintingOrder"
              @click="requestPrintOrder"
            >
              <b-spinner
                v-if="isPrintingOrder"
                variant="primary"
                small
              />
              <span
                v-else
                class="k-document-download"
              />
              {{ data.awb }}
            </b-button>
            <p
              v-else-if="!loading"
              class="text-black"
            >
              -
            </p>
          </div>
        </detail-row>
      </div>

      <div
        v-if="loading"
        class="mx-[20px] flex items-center justify-center gap-[10px] h-[150px] bg-[#f8f8f8] rounded-[8px]"
      >
        <b-spinner
          v-if="loading"
          variant="primary"
          small
        />
        <p class="mb-0">
          Memuat data...
        </p>
      </div>

      <detail-order
        v-else
        :data="data"
      />
    </div>

    <modal-loading-download
      ref="modalLoadingDownload"
    />
  </div>
</template>

<script>
import { toastError, toastSuccess } from '@/libs/toastification'
import moment from 'moment'
import DetailRow from './DetailRow.vue'
import { MARKETPLACE_PLATFORM } from './config'
import ModalLoadingDownload from '../ModalLoadingDownload.vue'
import DetailOrder from './DetailOrder.vue'

export default {
  name: 'DetailMarketplace',
  components: {
    DetailRow,
    ModalLoadingDownload,
    DetailOrder,
  },
  data() {
    return {
      loading: true,
      data: {},
      isPrintingOrder: false,
    }
  },
  computed: {
    marketplaceLogo() {
      return MARKETPLACE_PLATFORM[this.data.marketplace]?.logo || MARKETPLACE_PLATFORM.kompack.logo
    },
    loadingRowClass() {
      return this.loading && 'animate-pulse bg-[#f7f7f9] rounded-[4px] w-[150px] h-[22px]'
    },
  },
  async created() {
    this.getDetailMarketplace()
  },
  methods: {
    handleRefreshPage() {
      window.location.reload()
    },
    async getDetailMarketplace() {
      this.loading = true
      try {
        const { data } = await this.$http_new.get(`/komship/api/v1/marketplace-orders/${this.$route.params.id}/mitras`)

        if (!data?.data) {
          throw new Error('Data not found')
        }

        this.data = data?.data
        this.loading = false
      } catch (error) {
        this.isError = true
        toastError('Gagal mengambil data order marketplace. Silahkan coba lagi.')
      } finally {
        this.loading = false
      }
    },
    handleRetry() {
      this.getDetailMarketplace()
    },
    async requestPrintOrder() {
      this.isPrintingOrder = true
      this.$refs.modalLoadingDownload.showModal()
      try {
        const { data } = await this.$http_new.post('/label/api/v1/marketplace-labels/orders', {
          order_ids: [Number(this.$route.params.id)],
        }, {
          responseType: 'blob',
        })

        // if the response is a JSON, then we can show the error message
        if (data && data.type && data.type.includes('application/json')) {
          toastError('Gagal mencetak order, silahkan coba lagi')
          return
        }

        // if the response is a blob, then we can download the file
        if (data instanceof Blob) {
          const fileName = `marketplace-order-label-${this.data.marketplace_order_id}-${moment().format('DD-MM-YYYY_HH-mm')}.pdf`
          const url = window.URL.createObjectURL(data)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
          toastSuccess('Order berhasil dicetak ke perangkat Anda.', 'Cetak Order Berhasil')
        } else {
          toastError('Gagal mencetak order, silahkan coba lagi')
        }
      } catch (error) {
        toastError('Gagal mencetak order, silahkan coba lagi')
      } finally {
        this.isPrintingOrder = false
        this.$refs.modalLoadingDownload.closeModal()
      }
    },
  },
}
</script>
